import WorkshopList from 'components/Page/WorkshopList';
import Countdown from 'components/CountdownTimer';
import FeatureBlocksLottie from 'components/Page/Homepage/FeatureBlocksLottie';
import PrivacyRequestForm from 'components/Form/CCPAForm';
import VideoTheater from 'components/VideoTheater';
import CommercialFeatureList from 'components/Page/CommercialFeatureList';
import SocialProof from 'components/Sections/SocialProofSection/Simple';
import StateOfTheTradesReport from 'components/StateOfTheTradesReport';
import CustomerResourceHub from 'components/CustomerResourceHub';
import PowertheNation from 'components/PowerTheNation';

export default {
  Countdown,
  FeatureBlocksLottie,
  WorkshopList,
  PrivacyRequestForm,
  VideoTheater,
  CommercialFeatureList,
  SocialProof,
  StateOfTheTradesReport,
  CustomerResourceHub,
  PowertheNation,
};
